import{memo}from"react";import isEqual from"react-fast-compare";var fastCompare=function(a){return memo(a,isEqual)};export{fastCompare};
